/** A partir daqui a lista ganha busca por nome (achar o arquivo errado entre centenas). */
export const BUSCA_A_PARTIR_DE = 20;

export function tipoDe(nome: string): 'ZIP' | 'XML' | 'Planilha' {
  const n = nome.toLowerCase();
  if (n.endsWith('.zip')) return 'ZIP';
  if (n.endsWith('.xml')) return 'XML';
  return 'Planilha';
}

/** Identidade do arquivo escolhido: nome, tamanho e data. */
export const chaveDoArquivo = (a: File) => `${a.name}|${String(a.size)}|${String(a.lastModified)}`;

/** Mesmo arquivo escolhido de novo não entra duas vezes. */
export function juntarSemRepetir(atuais: readonly File[], novos: readonly File[]): File[] {
  const vistos = new Set(atuais.map(chaveDoArquivo));
  const resultado = [...atuais];
  for (const arquivo of novos) {
    if (vistos.has(chaveDoArquivo(arquivo))) continue;
    vistos.add(chaveDoArquivo(arquivo));
    resultado.push(arquivo);
  }
  return resultado;
}
